﻿<script setup lang="ts">
    import { useRoute, useRouter, RouterView } from 'vue-router';
    import SignedOut from '@cwd/Common/SignedOut.vue';
    import SignIn from './SignIn/SignIn.vue';
    document.body.classList.add('ug-bg');
    var route = useRoute();
    var router = useRouter();
</script>

<script lang="ts">
    export default {
        components: {},
        name: 'SignInRoot',
    };
</script>
<template>
    <SignedOut>
        <h1 class="h2 m-xl-t m-xl-b">{{ $Resources.SignInHeader }}</h1>

        <RouterView></RouterView>
    </SignedOut>
</template>

<style scoped></style>
